import { createApp } from 'vue'
import options from './ChatPanel.options'

const el = '.nyk-component--chat-panel'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    DOM.forEach((ChatPanelDOM) => {
        const labels = ChatPanelDOM.dataset.labels ? JSON.parse(ChatPanelDOM.dataset.labels) : null
        const feedbackActionId = ChatPanelDOM.dataset.feedbackActionId
        const color = ChatPanelDOM.dataset.color
        const filters = ChatPanelDOM.dataset.filters ? JSON.parse(ChatPanelDOM.dataset.filters) : null
        Store.commit('chatPanel/set_labels', labels)
        Store.commit('chatPanel/set_feedback_action_id', feedbackActionId)
        Store.commit('chatPanel/set_filters', filters)

        const template = ChatPanelDOM.innerHTML
        options.template = template
        const component = createApp(options, { color, ready: true, labels }).use(Store)
        component.mount(ChatPanelDOM)
    })
}